import React, { useState, useContext, useEffect } from 'react';
import { Button } from '@mui/material';
import { MapContext } from '../MapContext';
import { LayerContext } from '../LayerContext';
import { CatalogContext } from '../CatalogContext';
import { navbarHeight } from '../../config';

function BurgerMenuPane() {
  const {map} = useContext(MapContext);
  const layers = useContext(LayerContext);
  const {catalog, setCatalogContext }= useContext(CatalogContext);

  const handleButtonClick = ()=>{
    console.log(map.current.getStyle().layers); 
    console.log(map.current.getStyle().sources); 
    console.log(layers); 
    console.log(catalog);
  };

  return (
    <div  className="burger-menu-pane">
      <Button onClick={handleButtonClick}>Test</Button>
      {catalog?.id}
    </div>
  );
}

export default BurgerMenuPane;

